<div fxLayout="row" fxLayoutAlign="space-between center" >
    <div>
        {{message}}
    </div>
    <div>
        <a (click)="onDetails()" class="ml-12">Detalhes</a>
    </div>
</div>